import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {UPSELL_MODES} from '~/common/fabric/UpsellModal/UpsellModal';
import {shouldUseNamedStepsNav} from '~/common/utils/event_utils';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {DiamondIcon} from '~library/svg/DiamondIcon';

export const PremiumPreviewNav = ({
  isLargishAndUp,
  onClosePremiumPreviewClick,
  toggleUpsellModal,
}) => {
  const currentRoute = useCurrentRoute();
  const isStep1 = currentRoute?.name === 'customize' && !currentRoute?.meta?.editing;
  const upsellMode = isStep1 ? UPSELL_MODES.STEP_1_COPY : UPSELL_MODES.UNLOCK_DESIGN_TOOLS;
  const useNamedStepsNav = shouldUseNamedStepsNav();
  const mwPreviewCopy = useNamedStepsNav ? 'Premium feature' : 'Premium preview';

  return (
    <nav className="fabric-header__premium_preview_nav">
      <div className="premium-preview-container">
        <div className="premium-preview">
          <DiamondIcon ratio={1.25} />
          <Typography
            variant={isLargishAndUp ? 'paragraph2' : 'list1'}
            className="premium-preview-text--top"
          >
            {isLargishAndUp
              ? 'You are previewing a Premium feature. Like what you see?'
              : mwPreviewCopy}
          </Typography>
        </div>
        <div>
          <Typography variant="paragraph3" className="premium-preview-text--bottom">
            {!isLargishAndUp && 'Like what you see?'}
            <Button
              data-qa-id="upgrade-to-save"
              data-impression-tracking="true"
              variant="link"
              size={isLargishAndUp ? 'large' : 'small'}
              onClick={() => toggleUpsellModal(true, upsellMode)}
            >
              Upgrade now
            </Button>
          </Typography>
        </div>
      </div>
      <Button
        variant="link"
        data-qa-id="close-premium-preview"
        data-impression-tracking="true"
        onClick={onClosePremiumPreviewClick}
        ariaLabel="Close"
        className="premium-preview-close-button"
      >
        <CloseLineIcon ratio={0.75} />
      </Button>
    </nav>
  );
};
